module.exports = __webpack_public_path__ + "img/work1.4547dc62.png";